import {type FC, useMemo} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {CourseExpandedCommon} from '../../../../api/course';

import {CourseModel} from '../../../../utils/entity/course/createCourseModel';
import {CourseToJoinPreviewJSX} from '../../components/CourseToJoinPreview';

type Props = {
  course: CourseExpandedCommon;
};

export const CourseToJoinPreview: FC<Props> = ({course}) => {
  const {t} = useI18n();
  const model = useMemo(() => new CourseModel(course), [course]);

  const status = model.isAutoAccept ? t('shared:join_now') : model.statusString;

  return (
    <CourseToJoinPreviewJSX
      clientsAmount={model.clientsCount}
      groupSize={model.groupSize ?? 0}
      status={status}
      title={model.label}
    />
  );
};
